import {Card, CardContent, Grid} from '@mui/material';
import './card.css';
import {ICardLineMulti} from './ICardLine';

export default function CustomisedCardLine({itemList}: ICardLineMulti) {
    return (
        <Card
            className="!shadow-none"
            style={{
                width: '100%',
                height: 'fit-content',
                maxHeight: '100%',
                background: 'transparent',
                overflow: 'auto',
            }}
        >
            <CardContent
                className="cardDesign cardCantent !rounded-[0.5rem]"
                style={{height: '100% !important', overflow: 'auto'}}
                sx={{border: '1px solid var(--border-color)'}}
            >
                <Grid
                    container
                    xs={12}
                    style={{
                        paddingTop: '15px',
                        paddingBottom: '15px',
                    }}
                >
                    {itemList?.map((item: any, key: number) => (
                        <>
                            <Grid item xs={12}>
                                {key != 0 && (item?.value || item?.title) && (
                                    <hr
                                        className="grayLine"
                                        style={{
                                            marginBottom: '1vh',
                                            marginTop: '1vh',
                                        }}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container xs={12}>
                                    {item?.value && item?.title ? (
                                        <>
                                            <Grid
                                                item
                                                xs={6}
                                                className=" text-[var(--tirnary-text-color)] text-sm"
                                                style={{paddingTop: '0.2vh'}}
                                            >
                                                {item?.title}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={6}
                                                className=" text-sm !text-[var(--tirnary-text-color)]"
                                                style={{
                                                    paddingTop: '0.2vh',
                                                    textAlign: 'end',
                                                }}
                                            >
                                                <span className=" text-sm text-[var(--tirnary-text-color)]">
                                                    {!isNaN(+item.value)
                                                        ? item?.value.toLocaleString(
                                                              'fa'
                                                          )
                                                        : item?.value}
                                                </span>
                                            </Grid>{' '}
                                        </>
                                    ) : item?.title ? (
                                        <Grid
                                            item
                                            xs={12}
                                            className=" text-sm !text-[var(--tirnary-text-color)]"
                                            style={{paddingTop: '0.2vh'}}
                                        >
                                            <span className=" text-sm text-[var(--tirnary-text-color)]">
                                                {item?.title}
                                            </span>
                                        </Grid>
                                    ) : item?.value != null ? (
                                        <Grid
                                            item
                                            xs={12}
                                            className=" text-sm !text-[var(--tirnary-text-color)]"
                                            style={{paddingTop: '0.2vh'}}
                                        >
                                            <span className=" text-sm text-[var(--tirnary-text-color)]">
                                                {item?.value}
                                            </span>
                                        </Grid>
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
}
